import _ from 'lodash'

export default ({
  reading: { value },
  modelReadingType: {
    unit: { slug, symbol },
  },
}) => `${_.round(value * 100)}%`
